module.exports = "/images/arrow-up.svg?43986826b4d5d2d22aa2f0b25aa4585f";